import { EVENT_KEY, TRACKING_INTERACTION, TRACKING_ACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const userSettingsTracking = {
  trackUserSettings  (result = 'SUCCESS', failedReason = null) {
    const interaction = {
      navigate: ({ routeName }) => {
        const routes = {
          'help-start': TRACKING_INTERACTION.HELP_START,
          'release-notes': TRACKING_INTERACTION.RELEASE_NOTES,
          'settings-copyright': TRACKING_INTERACTION.SETTINGS_COPYRIGHT,
          'settings-videos': TRACKING_INTERACTION.SETTINGS_VIDEOS
        }
        const interaction = routes[routeName]
        if (!interaction) {
          console.warn(`Unknown route name for user settings tracking: ${routeName}`)
          return
        }
        return trackingUtils.track(EVENT_KEY.USER_SETTINGS.INTERACTION, { interaction })
      },
      logoutAllDevices: () => trackingUtils.track(EVENT_KEY.USER_SETTINGS.INTERACTION, { interaction: TRACKING_ACTION.LOGOUT_ALL_DEVICES })
    }

    const start = {
      openModal: ({ modalName }) => {
        const modalAction = {
          changeEmail: TRACKING_ACTION.CHANGE_EMAIL,
          changePassword: TRACKING_ACTION.CHANGE_PASSWORD,
          changeUsername: TRACKING_ACTION.CHANGE_USERNAME,
          twoStepVerification: TRACKING_ACTION.TWO_STEP_VERIFICATION
        }
        const action = modalAction[modalName]
        if (!action) {
          console.warn(`Unknown modal name for user settings tracking: ${modalName}`)
          return
        }
        return trackingUtils.track(EVENT_KEY.USER_SETTINGS.START, { action })
      },
      deleteAccount: ({ deletionFlow }) => trackingUtils.track(EVENT_KEY.USER_SETTINGS.START, { action: TRACKING_ACTION.DELETE_ACCOUNT, deletionFlow })
    }

    const end = {
      twoStepVerification: () => trackingUtils.track(EVENT_KEY.USER_SETTINGS.END, { action: TRACKING_ACTION.TWO_STEP_VERIFICATION, result, failedReason }),
      changeEmail: () => trackingUtils.track(EVENT_KEY.USER_SETTINGS.END, { action: TRACKING_ACTION.CHANGE_EMAIL, result, failedReason }),
      changePassword: () => trackingUtils.track(EVENT_KEY.USER_SETTINGS.END, { action: TRACKING_ACTION.CHANGE_PASSWORD, result, failedReason }),
      changeUsername: () => trackingUtils.track(EVENT_KEY.USER_SETTINGS.END, { action: TRACKING_ACTION.CHANGE_USERNAME, result, failedReason }),
      deleteAccount: ({ deletionFlow }) => trackingUtils.track(EVENT_KEY.USER_SETTINGS.END, { action: TRACKING_ACTION.DELETE_ACCOUNT, result, failedReason, deletionFlow })
    }

    return { interaction, end, start }
  }
}

export default userSettingsTracking
